export default __webpack_public_path__ + "static/media/practice-video.7e3b9424.mp4";